import React from "react";
import { Box, CircularProgress, Alert } from "@mui/material";
import { useParams, useSearchParams } from "react-router-dom";
import { ReactFlowProvider } from "reactflow"; // 🟢 Importando o Provider
import { useBotFlow } from "../../../hooks/useBotFlow";
import FlowEditor from "../../../components/FlowEditor";

const BotFlowEditor = () => {
  const { id: usuario } = useParams();
  const [searchParams] = useSearchParams();
  const identificador = searchParams.get("identificador") || null;

  const { data, error, isLoading } = useBotFlow(usuario, 0, identificador);

  if (!usuario) {
    return <Alert severity="error">Parâmetro 'usuario' não encontrado na URL.</Alert>;
  }

  return (
    <ReactFlowProvider> {/* ✅ Adicionando o Provider */}
      <Box sx={{ height: "90vh", width: "100%", position: "relative" }}>
        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Alert severity="error">Erro ao carregar o fluxo do bot. Tente novamente.</Alert>
        ) : (
          <FlowEditor initialNodes={data?.nodes} initialEdges={data?.edges} />
        )}
      </Box>
    </ReactFlowProvider>
  );
};

export default BotFlowEditor;
